/* @flow */

import { compose } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import {
  getEventLogo,
  getEventLogoAltText,
} from '@braindate/domain/lib/event/util';

import EventBrandingDumb from './EventBrandingDumb';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  variant: any,
  // Self passed
  intl: intlShape,
};

const mapStateToProps = (state: State, { variant, intl }: Props): Object => {
  const { locale } = intl;
  const event = getEventSafely(state);

  return {
    variant,
    logo: getEventLogo(event, locale),
    logoAltText: getEventLogoAltText(event, locale),
  };
};

// Make variants available
export * from './EventBrandingDumb';

export default compose(injectIntl, connect(mapStateToProps))(EventBrandingDumb);
